import { TextField } from '@material-ui/core';
import AutoComplete from '@material-ui/lab/Autocomplete';
import InputTitle from './InputTitle';

/**
 * @param {{
 *  placeholderLabel?: string;
 *  label: string;
 *  id: string;
 *  genericNotificationTemplates: AdminAppData.INotificationTemplate[];
 *  selectedNotif: Setup.INotificationTemplate;
 *  handleUpdateNotification: Function;
 * }} props
 */
function AutoCompleteSelect(props) {
    const {
        placeholderLabel = '',
        label,
        id,
        genericNotificationTemplates,
        selectedNotif,
        handleUpdateNotification,
    } = props;
    return (
        <div>
            <InputTitle>{label}</InputTitle>
            <AutoComplete
                id={id}
                value={genericNotificationTemplates.find((x) => x.id === selectedNotif.templateId)}
                options={genericNotificationTemplates}
                onChange={(_event, optionSelected) => handleUpdateNotification(optionSelected.id)}
                className="sue-autocomplete-full-width"
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        placeholder={placeholderLabel}
                    />
                )}
                getOptionLabel={(option) => option.name}
                includeInputInList
                disableClearable
            />
        </div>
    );
}

export default AutoCompleteSelect;
